import {
  ApiResponse,
  CreateBookingData,
  Lead,
  CreateApprovelRequestData,
  PaginatedApiResponse,
  ApprovalRequestList,
} from '../models';
import * as http from './http';
import ApiService from './service';

export class BookingService extends ApiService {
  async createBooking(data: { leadId: string; configId: string }) {
    const url = `${this.apiDomain}/api/booking`;
    const response = await http.post<ApiResponse<Lead>>(url, data, this.store);
    return response.data;
  }

  async approvelRequest(
    data: CreateApprovelRequestData & { configId: string }
  ) {
    const url = `${this.apiDomain}/api/booking/${data.configId}/requests`;
    const response = await http.post<ApiResponse<Lead>>(url, data, this.store);
    return response.data;
  }

  async getApprovelRequest(
    configId: string
  ): Promise<PaginatedApiResponse<ApprovalRequestList>> {
    const url = `${this.apiDomain}/api/booking/${configId}/requests`;

    const resposne = await http.get<PaginatedApiResponse<ApprovalRequestList>>(
      url,
      this.store
    );

    return {
      ...resposne.data,
    };
  }

  async approveRequest(data: CreateApprovelRequestData, requestId: string) {
    const url = `${this.apiDomain}/api/booking/requests/${requestId}/approve`;
    const response = await http.put<ApiResponse<Lead>>(url, data, this.store);
    return response.data;
  }
  async rejectRequest(data: CreateApprovelRequestData, requestId: string) {
    const url = `${this.apiDomain}/api/booking/requests/${requestId}/reject`;
    const response = await http.put<ApiResponse<Lead>>(url, data, this.store);
    return response.data;
  }
}
